import { z } from 'zod';
/**
 * Business error codes of the Cash Deposits API (cash-deposits.md), returned
 * as `error.code` in the standard error envelope. The web translates each one
 * in `errors.json` (ar and en); it never shows the server's English message.
 * They are part of `ERROR_CODES`.
 */
export const DEPOSIT_ERROR_CODES = [
    'AMOUNT_INVALID',
    'AMOUNT_DECIMALS_EXCEEDED',
    'CURRENCY_CODE_TAKEN',
    'CURRENCY_INACTIVE',
    'CURRENCY_IN_USE',
    'TABLET_NOT_CONFIGURED',
    'TABLET_UNAVAILABLE',
    'TABLET_NOT_AVAILABLE',
    'TABLET_BUSY',
    'TABLET_REQUEST_INVALID',
    'TABLET_TASK_CLOSED',
    'TABLET_TASK_NOT_SUBMITTED',
    'TABLET_TASK_KIND_MISMATCH',
    'SIGNATURE_REQUIRED',
    'FILE_TYPE_NOT_ALLOWED',
    'FILE_TOO_LARGE',
    'DEPOSIT_NOT_DRAFT',
    'DEPOSIT_DRAFT_NOT_OWNER',
    'DEPOSIT_CUSTOMER_NOT_PRESENT',
    'DEPOSIT_REFERENCE_UNKNOWN',
    'DEPOSIT_NOT_IN_CUSTODY',
    'DEPOSIT_OTHER_BRANCH',
    'DEPOSIT_BRANCH_NOT_ALLOWED',
    'DEPOSIT_REFERRAL_PENDING',
    'DEPOSIT_REFERRAL_NOT_PENDING',
    'DEPOSIT_FIELD_NOT_EDITABLE',
    'DEPOSIT_NO_CHANGES',
    'PHONE_TAKEN',
    'CUSTOMERS_UNAVAILABLE',
    'CUSTOMER_PHONE_REFUSED',
    'MESSAGE_NOT_RESENDABLE',
    // The phone rule (customers.md section 9.3).
    'PHONE_REQUIRED',
    'PHONE_INVALID',
    'PHONE_NOT_MOBILE',
    'PHONE_COUNTRY_NOT_ALLOWED',
    // WhatsApp phone verification (customers.md section 10), relayed from Customers.
    'PHONE_VERIFICATION_REQUIRED',
    'PHONE_VERIFICATION_INVALID',
    'PHONE_VERIFICATION_RECEIPT_EXPIRED',
    'OTP_INVALID',
    'OTP_EXPIRED',
    'OTP_ATTEMPTS_EXCEEDED',
    'OTP_RESEND_TOO_SOON',
    'OTP_SEND_LIMIT',
    'OTP_SEND_FAILED',
    'OTP_ALREADY_VERIFIED',
    'OTP_ALREADY_CONSUMED',
    'OTP_BINDING_MISMATCH',
    'OTP_NOT_VERIFIED',
    'OTP_CONSUME_WINDOW_PASSED',
    'IDEMPOTENCY_CONFLICT',
];
export const depositErrorCodeSchema = z.enum(DEPOSIT_ERROR_CODES);
//# sourceMappingURL=errors.js.map